// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aed5e2db","488":"9554e92a"}[chunkId] + ".chunk.js";
};